//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      template: {},
      view: false,
      edit: false
    };
  },
  methods: {
    onChangeName: function onChangeName(event) {}
  }
};